/*
* Authorizable mixin
* This mixin gives a component the ability to be authorized agains a set of permissions
*/
export default {
  props: {
    authorizedToBeEdited: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    /*
     * Query for an action authorization
     * @param {Object} action - Action to authorize
     * @return Boolean
     */
    async can(action, params = {}) {
      return this.$store.dispatch('authorization/AUTHORIZE', { action, ...params });
    },
  },
};
